module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/_perform.js
// module id = 213
// module chunks = 0